// third-party
import { t } from 'i18next';

// assets
import { ContactsOutlined } from '@ant-design/icons';

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const userAdmin = {
  id: 'maps',
  title: 'MAPS',
  type: 'group',
  children: [
    {
      id: 'userAdmin',
      title: 'USER_MGT',
      type: 'item',
      url: '/userAdmin',
      icon: ContactsOutlined
    }
  ]
};

export default [userAdmin];
